const filter = {
	$this: $( '.js-filter' ),
	$listing: $( '.js-items' ),
	$archive: $( '.js-items-archived' ),
	$archiveLabel: $( '.js-label-archived' ),
	$result: $( '.js-results > span'),
	$counter: $( '.js-open-filter > span'),
	$reset: $( '.js-reset-filter' ),
	$loader: $( '.js-filter-loader' ),
	$extraFilter: $( '.js-extra-filter' ),
	$filterSpacer: $( '.js-filter-spacer' ),
	$preFilter: $( '.js-pre-filter' ),
	used: false,
	noBigItems: true,
};

const numberOfGroups = filter.$this.find( '.js-filter-group' ).length;

let chosenFilters = {},
	loader = true,
	count_overtake = 0;

function resetFilter() {
	chosenFilters = {};
	count_overtake = 0;
	$( '.js-filter-item' ).removeClass( 'is-active' );
	$( '.js-filter-tag-remove' ).remove();
	updateCourses();
	createURL();
};

function removeFromChosenFilters( choice, group, label ) {
	if (chosenFilters[group] == undefined ) {
		chosenFilters[group] = { label: label, items: [] };
	}
	//chosenFilters[group]['items'].pop( choice ); // removes only last item!
	const filterArray = chosenFilters[group]['items'];
	const index = filterArray.indexOf(choice);

	filterArray.splice(index, 1);

	removeTag(choice, group)

	return chosenFilters;
}

function addToChosenFilters( choice, group, label, text ) {
	if (chosenFilters[group] == undefined || Object.entries(chosenFilters[group]).length === 0 ) {
		chosenFilters[group] = { label: label, items: [] };
	}
	chosenFilters[group]['items'].push( choice );


	if (choice !== undefined) {
		addTag(choice, group, label, text);
  }


	return chosenFilters;
}

function removeTag( choice, group ) {
	const tags = document.querySelector('.js-filter-tags');
	const tag = tags.querySelector(`.js-filter-tag-remove[data-filter-group='${group}'][data-filter='${choice}']`);
	tags.removeChild(tag);
}

function addTag( choice, group, label, text ) {
	const tags = document.querySelector('.js-filter-tags')

	// Create tag
	const tag = document.createElement('button');
	tag.classList.add('filter-tag__remove', 'js-filter-tag-remove', 'is-active');
	tag.setAttribute('aria-label', 'Verwijder filter');
	tag.setAttribute('data-filter-group', group);
	tag.setAttribute('data-filter-label', label );
	tag.setAttribute('data-filter', choice );

	const tagLabel = document.createElement('label');
	tagLabel.textContent = text;

	if (label === 'onderwijsgroep' || label === 'groep') {
		tagLabel.textContent = 'Groep ' + text;
	}

	const iconSpan = document.createElement('span');
	iconSpan.classList.add('icon');

	const icon = document.createElement('i');
	icon.setAttribute('aria-hidden', 'true');
	icon.setAttribute('role', 'presentation');
	icon.classList.add('svg-icon');
	icon.setAttribute('data-icon', 'icon-close');

	iconSpan.appendChild(icon);
	tag.appendChild(tagLabel);
	tag.appendChild(iconSpan);

	// addTag
	tags.appendChild(tag);
}

function getUrlVars() {
  var vars = {};
  var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
	 vars[key] = value.split( '+' );
  });
  return vars;
}

function createURL() {

	let urlFilters = '';

	//check which item belongs to chosen filter options
	if ( Object.entries(chosenFilters).length > 0 ) {
		for (var group in chosenFilters) {
			if (chosenFilters.hasOwnProperty(group)) {
				const label = chosenFilters[group].label;
				if ( '' == urlFilters ) {
					urlFilters += '?';
				}
				if ( chosenFilters[group].items.length > 0 ) {
					if ( urlFilters.length > 1 ) {
						urlFilters += '&';
					}
					urlFilters += label + '=';
					chosenFilters[group].items.forEach( function (item, i) {
						if ( i == 0 ) {
							urlFilters += item;
						} else {
							urlFilters += '+' + item;
						}
					} );
				}
			}
		}
	}

	var url = document.location.protocol + '//' + document.location.hostname + document.location.pathname;
	window.history.replaceState( {} , document.title, url + urlFilters );
}

function activateItemsBasedOnUrl() {
	const urlParams = getUrlVars();
	if ( Object.entries(urlParams).length !== 0 || urlParams.constructor !== Object ) {
		for (var label in urlParams) {
			for (var item in urlParams[label]) {
				const $item = $( '.js-filter-group, .js-extra-filter' ).find( `.js-filter-item[data-filter-label='${label}'][data-filter='${urlParams[label][item]}']` );
				activateItem( $item );
				// no loader after first time activeItem:
				if ( loader ) {
					loader = false;
				}
			}
		}
	} else {
		updateCourses();
	}
}

function activateItem( $item ) {
	if ( $item.hasClass( 'is-active' ) ) {
		$item.removeClass( 'is-active' );

		chosenFilters = removeFromChosenFilters( $item.data('filter'), $item.data('filter-group'), $item.data('filter-label') );
		// Remove from counter overtake if not main filter
		if ( ! $item.hasClass( 'js-filter-item--extra' ) ) {
			count_overtake --;
		}
		updateCourses();
		createURL();
	} else {
		$item.addClass( 'is-active' );
		filter.used = true;
		// If radio: unactivate other items in .filter-block:
		if ( $item.find( '.radio' ).length > 0 ) {
			$item.parents( '.js-filter-block' ).children( '.js-filter-item' ).each( function( ) {
				var $child = $( this );
				$child.removeClass( 'is-active' );
				chosenFilters = removeFromChosenFilters( $child.data('filter'), $child.data('filter-group'), $child.data('filter-label') );
			} );
		}
		// If 'filter-item-extra': unactivate siblings:
		if ( $item.hasClass( 'js-filter-item--extra' ) ) {
			$item.siblings( '.js-filter-item' ).each( function( $sibling ) {
				var $sibling = $( this );
				$sibling.removeClass( 'is-active' );
				chosenFilters = removeFromChosenFilters( $sibling.data('filter'), $sibling.data('filter-group'), $sibling.data('filter-label') );
			} );
		}
		// If 'filter-item-big': activate item in filter:
		if ( $item.hasClass( 'js-filter-item-big' ) ) {
			const filterValue = $item.attr('data-filter');
			filter.$this.find( '.filter-item[data-filter="'+ filterValue +'"]' ).addClass( 'is-active' );
		}
		chosenFilters = addToChosenFilters( $item.data('filter'), $item.data('filter-group'), $item.data('filter-label'), $item.find('.text').text());
		// Add to counter overtake if not main filter
		if ( ! $item.hasClass( 'js-filter-item--extra' ) ) {
			count_overtake ++;
		}
		updateCourses();
		createURL();
	}
};

function createCourseItem( data ) {

	var image = data.image;
	if ( image === null) {
		image = data.placeholder;
	}

	var icon;
	if (data.hasOwnProperty('icon') && typeof data.icon !== 'undefined') {
		icon = data.icon;
	} else {
		icon = '';
	}

	const isPO = document.querySelector('.content--courses-archive--po');
	const isScala = document.querySelector('.content--courses-archive--scala');
	const isScalaType = data.groups_term_names.group2 === 'Scala' ? 'js-is-scala' : '';

	let courseItem;

	const group3Array = data.groups_term_names.group3 ? data.groups_term_names.group3.split('_') : [];
	const group4Array = data.groups_term_names.group4 ? data.groups_term_names.group4.split('_') : [];

	//console.log(data.groups_term_names);

	let showThemes3 = chosenFilters.group3 && chosenFilters.group3.items && chosenFilters.group3.items.length > 0;
	let showThemes4 = chosenFilters.group4 && chosenFilters.group4.items && chosenFilters.group4.items.length > 0;

	if (isPO) {
		courseItem = `<a href="${data.url}" class="course-item-po course-item--po ${isScalaType}">
			<div class="course-item-image">
				<div class="load-image">
					<img data-src="${image}" alt="${data.image_alt}" src="" data-align="middle center" data-loader="false"/>
				</div>
				${icon && (`<div class="filter-icon-container"><img src="${icon}" class="filter-icon"></div>`)}
			</div>
			<div class="course-item-content">
				<h2 class="small">${data.title}</h2>
				<div class="info-group">
					${data.groups_term_names.group1 && (`<div class="info__group">
						<label>Groep</label>
						<span class="group">${data.groups_term_names.group1}</span>
					</div>`)}
					${data.groups_term_names.group2 && (`<div class="info__type">
						<label>Soort</label>
						<span class="type">${data.groups_term_names.group2}</span>
					</div>`)}
					${!isScalaType && data.groups_term_names.group3 ? (`<div class="info__discipline">
						<label>Discipline</label>
						<span class="discipline">${data.groups_term_names.group3}</span>
					</div>`) : ''}
				</div>
				${isScalaType && data.groups_term_names.group3 && (`<span class="genre">${data.groups_term_names.group3}</span>`)}
				${group4Array.length > 0 && showThemes4 ? (`<div class="themes">
					<label>Thema's</label>
					${group4Array.map(theme => `<span class="theme">${theme}</span>`).join('')}
				</div>`) : ''}
			</div>
		</a>`;
	} else if (isScala) {
		courseItem = `<a href="${data.url}" class="course-item-scala course-item--scala">
		<div class="course-item-image">
			<div class="load-image">
				<img data-src="${image}" alt="${data.image_alt}" src="" data-align="middle center" data-loader="false"/>
			</div>
			${icon && (`<div class="filter-icon-container"><img src="${icon}" class="filter-icon"></div>`)}
		</div>
		<div class="course-item-content">
			<h2 class="small">${data.title}</h2>
			<span class="type">${data.groups_term_names.group4}</span>
			${group3Array.length > 0 && showThemes3 ? (`<div class="themes">
				<label>Thema's</label>
				${group3Array.map(theme => `<span class="theme">${theme}</span>`).join('')}
			</div>`) : ''}
		</div>
	</a>`;
	} else {
		courseItem = `<div class="course-item-outer"><a href="${data.url}" class="course-item">
			<div class="course-item-image">
				<div class="load-image">
					<img data-src="${image}" alt="${data.image_alt}" src="" data-align="middle center" data-loader="false"/>
				</div>
				${icon && (`<div class="filter-icon-container"><img src="${icon}" class="filter-icon"></div>`)}
			</div>
			<div class="course-item-content">
				<h2 class="small">${data.title}</h2>
				<span class="genre">${data.groups_term_names.group4}</span>
				<span class="type">${data.groups_term_names.group2}</span>
			</div>
		</a></div>`;
	}

	return courseItem;
}

function updatedSelectedPerGroup() {
	const $groups = $( '.js-filter-group' );
	const $results = $groups.find( '.js-selected' );
	$results.addClass('is-hidden');

	for (const group in chosenFilters) {
		if (chosenFilters.hasOwnProperty(group)) {
			const $results = $( '.js-filter-group' ).find( `[data-group='${group}']` );
			$results.text( chosenFilters[group]['items'].length );
			$results.parent('.js-selected').removeClass('is-hidden');
		}
	}
}

function updateResults( count_results ) {
	filter.$result.text( count_results );
};

function updateSelected( count_overtake ) {
	if( count_overtake  == 0 ){
		filter.$counter.removeClass('counter' );
		filter.$counter.html( '<i class="svg-icon" data-icon="icon-filter" data-fill="#fff"></i>' );
	} else {
		filter.$counter.addClass('counter' );
		filter.$counter.text( count_overtake );
	}
};

function getShowGroups( data, group ) {
	var show_group = false;
	// forEach is synchronous!, return will work AFTER forEach is done.
	chosenFilters[ group ][ 'items' ].forEach( function( item ) {
		if (data.groups[ group ].includes( item )) {
			if (!show_group) {
				// TODO: kan includes handiger?
				show_group = data.groups[ group ].includes( item );
			}
		}
	} );
	return show_group;
}

function updateCourses() {

	// ====== if filter at least once used or opened ======
	if ( filter.used || filter.noBigItems ) {

		filter.$preFilter.addClass('is-hidden');
		filter.$listing.removeClass( 'is-visible' ).html('');

		if ( 'undefined' != typeof archivedCourses ) {
			filter.$archive.removeClass( 'is-visible' ).html('');
		}

		if ( loader ) {
			filter.$loader.fadeIn();
		}

		let count_results = 0;

		// are previously selected filters empty?
		if (Object.entries(chosenFilters).length > 0) {

				$.each(chosenFilters, function( group, data ){
					if(data['items'].length === 0 ){
						//console.log('is empty');
						delete chosenFilters[group];
					}
				});
		}

		// === if noFilters are selected ===
		let noFilters = Object.entries(chosenFilters).length === 0 && chosenFilters.constructor === Object ? true : false;

		let archive_results = 0;

		if ( noFilters ) {
			// if no filters, no checks need to be done, all items shown:
			$.each( $.parseJSON( resultCourses ), function( i, data ) {
				let courseItem = createCourseItem( data );
				filter.$listing.append( courseItem );
				count_results++;
			} );

			if ( 'undefined' != typeof archivedCourses ) {
				$.each( $.parseJSON( archivedCourses ), function( i, data ) {
					let courseItem = createCourseItem( data );
					filter.$archive.append( courseItem );
					count_results++;
					archive_results++;
				} );
			}

		} else { // === if filters are selected ===

			$.each( $.parseJSON( resultCourses ), function( i, data ) {

				let show_groups = [];

				for ( var j = 1; j <= numberOfGroups; j++ ) {
					let show_group = true;
					let group = 'group' + j;

					if (data.groups[group] && data.groups[group].length > 0 && chosenFilters[group] != undefined && chosenFilters[group]['items'].length > 0 ) {
						show_group = getShowGroups( data, group );
					}
					// don't show items with no entry for selected group
					if( !data.groups[group] && chosenFilters[group] != undefined ){
						show_group = false;
					}

					show_groups.push(show_group);
				}

				let itemShouldBeShown = show_groups.every( el => el === true );

				if ( itemShouldBeShown ) {
					let courseItem = createCourseItem( data );
					filter.$listing.append( courseItem );
					count_results++;
				}
			} );

			if ( 'undefined' != typeof archivedCourses ) {
				$.each( $.parseJSON( archivedCourses ), function( i, data ) {

					let show_groups = [];

					for ( var j = 1; j <= numberOfGroups; j++ ) {
						let show_group = true;
						let group = 'group' + j;

						if (data.groups[group] && data.groups[group].length > 0 && chosenFilters[group] != undefined && chosenFilters[group]['items'].length > 0 ) {
							show_group = getShowGroups( data, group );
						}
						// don't show items with no entry for selected group
						if( !data.groups[group] && chosenFilters[group] != undefined ){
							show_group = false;
						}

						show_groups.push(show_group);
					}

					let itemShouldBeShown = show_groups.every( el => el === true );

					if ( itemShouldBeShown ) {
						let courseItem = createCourseItem( data );
						filter.$archive.append( courseItem );
						count_results++;
						archive_results++;
					}
				} );
			}
		}

		updateResults( count_results );
		updateSelected (count_overtake );
		updatedSelectedPerGroup();

		scalaPopup();

		filter.$loader.fadeOut( 300, function() {

			// if no results:
			if (count_results == 0) {
				filter.$listing.html('<p class="msg-no-results">Er zijn geen resultaten gevonden.</p>').addClass( 'is-visible');
			}

			filter.$listing.addClass( 'is-visible' );

			if ( archive_results == 0 ) {
				filter.$archiveLabel.addClass('is-hidden').removeClass('is-visible');
				filter.$archive.addClass('is-hidden').removeClass('is-visible');
			} else {
				filter.$archiveLabel.removeClass('is-hidden').addClass('is-visible');
				filter.$archive.removeClass('is-hidden').addClass('is-visible');
			}

			setTimeout( function() {
				filter.$listing.icons.init( '.svg-icon' );
				filter.$listing.find( '.load-image' ).imageLoader();
				filter.$archive.icons.init( '.svg-icon' );
				filter.$archive.find( '.load-image' ).imageLoader();
			}, 500 );

		});

	}

}

function toggleGroups() {
	const dropdownGroups = document.querySelectorAll(".js-filter-group")

	dropdownGroups.forEach( function( group ) {
		const dropdownBtn = group.querySelector(".js-filter-group__button")
		const dropdownMenu = group.querySelector(".js-filter-items")

		// Open de dropdown bij klikken:
		dropdownBtn.addEventListener("click", function () {
			openGroup();
		});

		// Sluit de dropdown als je ergens buiten klikt:
		document.addEventListener("click", function (e) {
			if (!dropdownBtn.contains(e.target) && !dropdownMenu.contains(e.target)) {
				closeGroup();
			}
		});

		// Sluit de dropdown als je op ESC
		document.addEventListener("keydown", function (e) {
			if (e.key === "Escape") {
				closeGroup();
			}
	  	});

		function openGroup() {
			const expanded = dropdownBtn.getAttribute("aria-expanded") === "true"
			dropdownBtn.setAttribute("aria-expanded", !expanded)
			dropdownMenu.style.display = expanded ? "none" : "block"
			dropdownMenu.setAttribute("aria-hidden", expanded ? "true" : "false")
		}

		function closeGroup() {
			dropdownMenu.style.display = "none";
			dropdownBtn.setAttribute("aria-expanded", "false");
			dropdownMenu.setAttribute("aria-hidden", "true");
		}
	});
}

function scalaPopup() {

		// on click "scala item" open pop-up
		document.querySelectorAll('.js-is-scala').forEach((el) => {

			el.addEventListener("click", (e) => {

				e.preventDefault();
				e.stopPropagation();

				const href = el.getAttribute('href');

				$(".favorites--alert-content").append(
					`<p><strong>Let op: dit is aanbod van Scala</strong></p>
					<p>Deze Scala-lessenserie kan ook in verkorte vorm worden aangevraagd. Neem contact op met <a href="mailto:planning@dekubuslelystad.nl">planning@dekubuslelystad.nl</a>.</p>
					<div class="button-container">
						<button class="btn btn--outline js-close-popup">Terug naar PO aanbod</button>
						<a href="${href}" class="btn btn--black" >Ga naar Scala aanbod</a>
					</div>`
				);

				document.querySelector('.js-scala-alert').classList.add('favorites--alert__active');

				document.querySelector('.js-close-popup').addEventListener("click", (e) => {
					e.preventDefault();
					document.querySelector('.js-scala-alert').classList.remove('favorites--alert__active');
					$(".favorites--alert-content").empty();
				}
				);

			});
		});
	}

filter.init = function() {

	activateItemsBasedOnUrl(); // updateCourses in this function

	filter.$reset.on( 'click', function( e ) {
		e.preventDefault();
		resetFilter();
	} );

	// Open / close groups:
	toggleGroups();

	// On click & Enter filter-item:
	$( '.js-filter-item:not(.is-inactive)' ).on( 'click keydown', function( e ) {
		if (e.type === 'click' || (e.type === 'keydown' && e.key === 'Enter')) {
			e.preventDefault();
			e.stopPropagation();
			activateItem( $(this) );
		}
  } );

  // On click & Enter tag
  $(document).on('click keydown', '.js-filter-tag-remove', function(e) {
	if (e.type === 'click' || (e.type === 'keydown' && e.key === 'Enter')) {
		e.preventDefault();
		e.stopPropagation();
		activateItem( $(this) );

		// Unselect filter-item:
		$( '.js-filter-item[data-filter-group="'+ $(this).data('filter-group') +'"][data-filter="'+ $(this).data('filter') +'"]' ).removeClass( 'is-active' );
	}
} );
};

export { filter };
